var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","open-delay":"100","max-width":"400","nudge-bottom":"10","transition":"slide-y-transition","color":"#333"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"cursor":"help"},attrs:{"right":"","size":"20","color":_vm.color}},'v-icon',attrs,false),on),[_vm._v("mdi-help-circle")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }